import { Observable } from "rxjs";
import { RedemptionResult } from "../../shared/enums/coupon.enums";

// Re-export so consumers import from the facade, not the enum file directly.
export { RedemptionResult };

export interface ICouponRedeemService {
  readonly useScan: boolean;
  readonly requiredCouponLength: number;
  readonly isAppCouponActive: boolean;
  readonly appCoupons$: Observable<ReadonlyArray<IAppCoupons>>;
}

export interface IAppCoupons {
  readonly id: number;
  readonly couponCode: string;
  readonly anonymCode: boolean;
  readonly hasImage: boolean;
  readonly image: string;
  readonly isRedeemed: boolean;
  readonly isRedeemOncePerUser: boolean;
}

/** Coupon fields needed to redeem it. */
export interface CouponRedemptionData {
  readonly id: number;
  readonly isRedeemed: boolean;
  /** qr_code_text; only used for multi-use coupons. */
  readonly couponCode: string;
  readonly anonymCode: boolean;
  readonly isRedeemOncePerUser: boolean;
}

/** Server reservation; the IDs and code are only set on Proceed. */
export interface RedemptionReservation {
  readonly result: RedemptionResult;
  readonly redemptionId?: number;
  readonly code?: string;
  readonly productId?: number;
}
